import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"xs":"12","sm":"6","md":"4"}},[_c(VImg,{staticClass:"mb-2",attrs:{"src":require('../assets/images/logo b text.svg'),"alt":"Logo","width":"192"}}),_c('p',[_vm._v(" Reflex Web Portal ")]),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }